import React, { useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { Dispatch } from "redux";
import { fetchApi } from "../../redux/fetch/fetch.actions";
import { GlobalState } from "../../redux/root-reducer";
import { connect } from "react-redux";
import Loading from "../../components/loading/loading.component";
import { removeCookie } from "../../redux/utils/cookie";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    logout: () => void;
}

function LogOutContainer({ isFetching, errors, logout }: IProps) {
    const hasFetch = useRef(false);

    useEffect(() => {
        if (isFetching) {
            hasFetch.current = true;
        }
    }, [isFetching]);

    useEffect(() => {
        if (isFetching || errors) return;
        logout();
        return () => {
            removeCookie("_s");
        };
    }, [isFetching, errors, logout]);

    return (
        <div className="log-out">
            {!hasFetch.current || isFetching ? (
                <Loading className="fixed" />
            ) : (
                <Redirect to="/login" />
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
}: GlobalState) => ({
    isFetching: isFetching.LOGOUT,
    errors: errors.LOGOUT,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logout: () => dispatch(fetchApi({ name: "LOGOUT" })),
});

const LogOut = connect(mapStateToProps, mapDispatchToProps)(LogOutContainer);
export default LogOut;
